import { PropsWithChildren, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useRecoilState } from "recoil";
import { ShowProgress } from "../states/ShowProgress";
import { Backdrop, CircularProgress } from "@mui/material";
import { SideMenu } from "./SideMenu";
import Backtotop from "../component/Backtotop";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const WrappedLayout: React.FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const [showProgress] = useRecoilState(ShowProgress);
  const [MyclassName, setMyClass] = useState("");

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: "en",
          "data-menu-styles": "dark",
          dir: "ltr",
          class: "light",
          "data-nav-layout": "vertical",
          "data-header-styles": "light",
          "data-vertical-style": "overlay",
          "icon-text": MyclassName,
        }}
      />
      <div className="page">
        <SideMenu />
        <Header />
        <div className="content">
          <div className="main-content">{children}</div>
        </div>
        <Footer />
      </div>
      <Backtotop />
      <div id="responsive-overlay"></div>
      <Backdrop sx={{ color: "#fff", zIndex: 10000 }} open={showProgress}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};
